<template>
  <v-dialog
    v-model="visivel"
    persistent
    width="auto"
    height="auto"
    @click:outside="cancela">
    <v-card class="mt-3 pa-4" outlined>
      <button class="float-right" @click="cancela">
        <v-icon color="primary">close</v-icon>
      </button>

      <v-card-title
        class="flex-column justify-center primary--text font-weight-bold clear-both">
        <v-icon size="100" color="primary">{{ icon }}</v-icon>
        <p>{{ mensagem }}</p>
      </v-card-title>

      <v-card-text class="text-center">
        {{ corpoMensagem }}
      </v-card-text>
      <v-flex class="d-flex flex-column align-center">
        <v-container>
          <v-textarea
            auto-grow
            autofocus
            class="d-flex flex-column align-center w-100"
            label="Diga o motivo"
            v-model="confirmationDialog.motivo"
            outlined
            hide-details="false"></v-textarea>
        </v-container>
        <v-flex class="d-flex flex-row align-center w-100">
          <template>
            <v-row class="mr-5">
              <v-menu bottom transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    text
                    x-small
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on">
                    Deseja usar um motivo pronto ?
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item v-for="(item, i) in items" :key="i" link>
                    <v-list-item-title @click="handleOnClick(item)">{{
                      item.title
                    }}</v-list-item-title>
                    <v-list-item-action>
                      <v-btn
                        :class="'red--text'"
                        icon
                        @click="deletarJustificativa(item)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-row>

            <div>
              <v-menu
                v-model="saveDialog.menu"
                :close-on-content-click="false"
                :nudge-width="200"
                offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="getTexto"
                    text
                    x-small
                    required
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on">
                    Deseja salvar o motivo atual ?
                  </v-btn>
                </template>
                <ValidationObserver v-slot="{ invalid }">
                  <v-form @submit.prevent="criarJustificativa" ref="form">
                    <v-card>
                      <v-list>
                        <v-list-item>
                          <ValidationProvider
                            name="validateTitulo"
                            rules="required"
                            v-slot="{ errors, valid }">
                            <v-text-field
                              required
                              auto-grow
                              autofocus
                              label="Digite o titulo"
                              :error-messages="errors"
                              :sucess="valid"
                              v-model="saveDialog.titulo"></v-text-field>
                          </ValidationProvider>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content>
                            <ValidationProvider
                              name="validateTexto"
                              rules="required"
                              v-slot="{ errors, valid }">
                              <v-textarea
                                label="Digite uma justificativa"
                                v-model="saveDialog.texto"
                                :error-messages="errors"
                                :sucess="valid"
                                outlined
                                hide-details="false">
                              </v-textarea>
                            </ValidationProvider>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list>

                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn text @click="saveDialog.menu = false">
                          Cancelar
                        </v-btn>
                        <v-btn
                          type="submit"
                          :disabled="invalid"
                          color="primary"
                          text>
                          Salvar
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-form>
                </ValidationObserver>
              </v-menu>
            </div>
          </template>
        </v-flex>
      </v-flex>
      <v-card-actions class="justify-space-around">
        <slot>
          <template v-if="tipo === 'confirma'">
            <v-btn
              @click="confirma"
              class="pa-4"
              min-width="100"
              min-height="50"
              color="primary"
              outlined>
              Sim
            </v-btn>
            <v-btn
              @click="cancela"
              class="pa-4 ml-6"
              min-width="100"
              min-height="50"
              color="primary">
              Não
            </v-btn>
          </template>
          <template v-else>
            <v-btn
              block
              class="text-capitalize"
              color="primary"
              @click="confirma"
              >Ok</v-btn
            >
          </template>
        </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions } from "vuex"
import { RepositoryFactory } from "../../repositories/repositoryFactory"
import { ValidationObserver, ValidationProvider } from "vee-validate"

const justificativasRepository = RepositoryFactory.get("justificativa")

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
  },

  data: () => ({
    confirmationDialog: {
      title: "",
      message: "",
      motivo: "",
    },

    saveDialog: {
      menu: false,
      texto: "",
      titulo: "",
    },

    items: null,
  }),
  mounted() {
    if (this.isAdministrador) {
      this.getJustificativa()
    }
  },
  methods: {
    async criarJustificativa() {
      const justificativaPayload = {
        data: {
          titulo: this.saveDialog.titulo,
          motivo: this.saveDialog.texto,
          users_permissions_user: this.userId,
        },
      }
      try {
        const response = await justificativasRepository.create(
          justificativaPayload
        )
        this.saveDialog.menu = false
        this.items.push({
          title: response.data.data.attributes.titulo,
          index: response.data.data.id,
          motivo: response.data.data.attributes.motivo,
        })
        this.showSucesso("Justificativa salva com sucesso")
      } catch (error) {
        this.showErro("Justificativa não salva")
      }
    },
    getTexto() {
      this.saveDialog.titulo = ""
      this.saveDialog.texto = this.confirmationDialog.motivo
    },
    async getJustificativa() {
      this.items = await justificativasRepository.get().then((res) =>
        res.data.data.map((item) => {
          return {
            title: item.attributes.titulo,
            index: item.id,
            motivo: item.attributes.motivo,
          }
        })
      )
    },
    async deletarJustificativa(item) {
      try {
        await justificativasRepository.delete(item.index)
        const index = this.items.indexOf(item)
        this.items.splice(index, 1)
        this.showSucesso("Justificativa deletada com sucesso")
      } catch (error) {
        this.showErro("Justificativa não deletada")
      }
    },
    handleOnClick(item) {
      this.confirmationDialog.motivo = item.motivo
    },
    cancela() {
      this.$emit("close")
    },
    confirma() {
      this.$emit("close")
      this.$emit("confirma", { motivo: this.confirmationDialog.motivo })
    },
    ...mapActions("message", ["showSucesso", "showErro"]),
  },
  props: {
    tipo: {
      type: String,
    },
    mensagem: {
      type: String,
    },
    corpoMensagem: {
      type: String,
    },
    visivel: {
      type: Boolean,
    },
  },
  computed: {
    icon() {
      switch (this.tipo) {
        case "informa":
          return "mdi-check-circle-outline"

        case "alerta":
          return "mdi-alert-circle-outline"

        case "confirma":
          return "mdi-cancel"

        default:
          return this.tipo
      }
    },

    ...mapGetters({
      isAdministrador: ["auth/isAdministrador"],
      nome: ["auth/username"],
      userId: ["auth/userId"],
    }),
  },
}
</script>

<style>
.clear-both {
  clear: both;
}
</style>
